module.exports = __webpack_public_path__ + "img/1.83ef2d6f.png";